export const STATIC_CONTENT_TYPE = [
  { name: "PRIVACY POLICY", type: 1, id: "6776e327c30cb08fc7123042" },
  { name: "TERMS AND CONDITIONS", type: 2, id: "6776e32cc30cb08fc7123047" },
  { name: "CONTACT US", type: 3, id: "6776e332c30cb08fc712304c" },
  { name: "FAQ", type: 4, id: "6776e337c30cb08fc7123051" },
  // { name: "FAQS", type: 5, id: "5" },
];

export const DIVE_TYPES = {
  Wreck: "wreck",
  Reef: "reef",
  Cave: "cave",
  Ice: "ice",
  Rescue: "rescue",
  Technical: "technical",
  Exploration: "exploration",
};

export const FeedbackStatus = {
  Pending: "1",
  Completed: "4",
};
